import React from "react";

export const CasinoCardIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    data-ds-icon="Casino"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      fill="currentColor"
      d="m2.14 4.63 7.25-3.38c.63-.3 1.34-.23 1.89.11-.09.14-.18.28-.26.43L4.81 15.1 1.17 7.29c-.47-1-.03-2.19.97-2.66Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m21.86 4.63-7.25-3.38c-1-.47-2.19-.03-2.66.97l-6.76 14.5c-.47 1-.03 2.19.97 2.66l7.25 3.38c1 .47 2.19.03 2.66-.97l6.76-14.5c.47-1 .03-2.19-.97-2.66Zm-9.54 11-.85-4.81 2.3-4.4.85 4.81-.85 4.4h-1.45Z"
      clipRule="evenodd"
    />
  </svg>
);

export const TelegramPaperPlaneIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.7 3.24c.33-.14.68.17.58.52l-4.7 16.87c-.1.37-.55.5-.84.25l-4.82-4.2-2.74 2.65c-.33.32-.89.09-.89-.37v-3.88l9.61-8.66c.22-.2-.05-.54-.3-.38L6.05 13.18 1.9 11.87c-.4-.13-.44-.67-.07-.85L21.7 3.24Z"
    />
  </svg>
);

const BTI_LOGO_DATA_URI = "data:image/webp;base64,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";
const SABA_LOGO_DATA_URI = "data:image/webp;base64,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";

const SportsbookBrandLogoIcon = ({
  className = "",
  iconName,
  source,
  sourceWidth,
  sourceHeight,
  ...props
}) => (
  <svg
    className={className}
    data-ds-icon={iconName}
    data-source-width={sourceWidth}
    data-source-height={sourceHeight}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <image
      data-icon-part="brand-artwork"
      href={source}
      x="1"
      y="1"
      width="22"
      height="22"
      preserveAspectRatio="xMidYMid meet"
      style={{
        filter: "grayscale(1) brightness(0) invert(1)",
        opacity: 0.98,
      }}
    />
  </svg>
);

export const BtiSportsbookLogoIcon = (props) => (
  <SportsbookBrandLogoIcon
    {...props}
    iconName="BtiSportsbook"
    source={BTI_LOGO_DATA_URI}
    sourceWidth="70"
    sourceHeight="50"
  />
);

export const SabaSportsbookLogoIcon = (props) => (
  <SportsbookBrandLogoIcon
    {...props}
    iconName="SabaSportsbook"
    source={SABA_LOGO_DATA_URI}
    sourceWidth="60"
    sourceHeight="60"
  />
);

const FilledWalletBody = () => (
  <>
    <path
      d="M4.3 4.25h13.9a2.15 2.15 0 0 1 2.15 2.15v2.35H2.4V6.15c0-1.05.85-1.9 1.9-1.9Z"
      fill="currentColor"
      fillOpacity="0.34"
    />
    <path
      d="M4.45 7h15.1A2.45 2.45 0 0 1 22 9.45v8.2A3.35 3.35 0 0 1 18.65 21H4.45A2.45 2.45 0 0 1 2 18.55v-9.1A2.45 2.45 0 0 1 4.45 7Zm13.3 5a2.5 2.5 0 0 0 0 5H22v-5h-4.25Z"
      fill="currentColor"
      fillOpacity="0.78"
      fillRule="evenodd"
      clipRule="evenodd"
    />
    <path
      d="M5.25 9.15h9.1a.7.7 0 0 1 0 1.4h-9.1a.7.7 0 1 1 0-1.4Z"
      fill="currentColor"
      fillOpacity="0.3"
    />
    <circle cx="18.15" cy="14.5" r="1" fill="currentColor" />
  </>
);

const WalletDirectionBadge = ({ direction }) => {
  const badgePath = direction === "deposit"
    ? "M7 1.25a5.75 5.75 0 1 1 0 11.5A5.75 5.75 0 0 1 7 1.25Zm-.85 2.4h1.7v3.4h1.7c.45 0 .67.54.36.86L7.6 10.3a.82.82 0 0 1-1.2 0L4.1 7.91c-.31-.32-.08-.86.36-.86h1.69v-3.4Z"
    : "M17 1.25a5.75 5.75 0 1 1 0 11.5 5.75 5.75 0 0 1 0-11.5Zm-.6 2.42-2.31 2.4c-.31.32-.08.86.36.86h1.7v3.4h1.7v-3.4h1.7c.45 0 .67-.54.36-.86l-2.31-2.4a.82.82 0 0 0-1.2 0Z";

  return (
    <path
      data-icon-part={`${direction}-badge`}
      d={badgePath}
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  );
};

export const WalletDepositIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    data-ds-icon="WalletDeposit"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <FilledWalletBody />
    <WalletDirectionBadge direction="deposit" />
  </svg>
);

export const WalletWithdrawalIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    data-ds-icon="WalletWithdrawal"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <FilledWalletBody />
    <WalletDirectionBadge direction="withdrawal" />
  </svg>
);
